import Card from "../../../components/Card";
import DropIcon from "../../../assets/Icons/dropdownIcon.svg";
import ChatIcon from "../../../assets/Icons/ChatIcon";
import { Link } from "react-router-dom";
import { EMIText, LoanStatusText, LoanTenureText } from "../../Home/component/RecomendedLoanSection";
import { useState } from "react";
import DropdownTexts from "./DropdownTexts";
import { Button } from "../../../components/Buttons";
import DownloadIcon from "../../../assets/Icons/DownloadIcon";
import ViewIcon2 from "../../../assets/Icons/ViewIcon2";
import InfoIcon from "../../../assets/Icons/InfoIcon";
const PastLoanCard = ({ loanType, id, totalAmount, interest, tenure, statusColor, value, loanDate, type, balance }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const RejectionList = [
    "signature mismatch",
    "name mismatch on Aadhaar & pan",
    "invalid Pan number",
    "invalid Aadhaar number",
    "mobile number not linked to pan",
    "KYC not done"
  ];
  return (<div className="flex">
    <Card className={"p-[8px] md:py-[18px] md:px-[18px]  min-w-full md:min-w-[480px]"} >
      <div className="flex justify-between">
        <div className="col-span-3">
          <div className="flex">
            <div className="flex gap-[12px] cursor-pointer items-center" onClick={toggleDropdown}>
              <p className="font-Apparat font-[700] text-[20px] leading-[24px] tracking-[-2%]">{loanType}</p>
              <img src={DropIcon} className="h-[12px] w-[12px]" />
            </div>

          </div>

          {!dropdownOpen && <p className="font-[600] text-[16px] text-[#42495280] leading-[18.5px] tracking-[-2%] mt-[4px] hidden md:block">ID:
            <span className="text-[#424952]">{id}</span>
          </p>}
        </div>
        <div className=" ">
          <div className="flex md:hidden gap-[4px]">
            {type == "completed" ? <>
              <Button variant="quaternary" className="  flex justify-center !text-[#424952] bg-[white] !text-[12px] border-0 shadow-none px-[2px]">
                <p className="flex gap-[2px]"><span><DownloadIcon /></span> NOC</p>
              </Button>
              <Button variant="quaternary" className=" flex justify-center !text-[#424952] bg-[white] !text-[12px] border-0 shadow-none px-[2px]">
                <p className="flex gap-[2px]"><span><DownloadIcon /></span> Statement</p>
              </Button>
            </> :
              <LoanStatusText title="" statusClass={statusColor} status={value} />
            }

          </div>
          <Link class="text-primary font-Apparat font-[700] text-[18px] leading-[30px] tracking-[-2%] hidden md:flex items-center gap-[4px] ">
            <ChatIcon />
            <span>Support</span>
          </Link>
        </div>
      </div>
      {!dropdownOpen && <div className="grid grid-cols-4  gap-[4px]">
        <div className="col-span-1">
          <LoanTenureText title="Amount" value={`₹ ${totalAmount}`} />
        </div>
        <div className="col-span-1  text-start">
          <div>
            <LoanTenureText title="interest" value={`${interest}`} />
          </div>
        </div>
        <div className="col-span-1 text-start">
          <div>
            <LoanTenureText
              title="tenure"
              value={`${tenure}`}
              className="hidden md:block"
            />
            <LoanTenureText
              title="inst"
              value={8}
              className="block md:hidden"
            />
          </div>
        </div>
        <div className="col-span-1  text-end">
          <div>
            <LoanTenureText
              title="EMI"
              value={`₹ ${balance}`}
              className="block md:hidden"
            />
            <LoanTenureText
              title="Balance"
              value={`₹ ${balance}`}
              className="hidden md:block"
            />
          </div>
        </div>
      </div>}
      {dropdownOpen && <div className="flex flex-col gap-[12px] mt-[8px]">
        <DropdownTexts
          label={"applied on"}
          value={loanDate}
        />
        {type == "completed" && <DropdownTexts
          label={"issued on"}
          value={loanDate}
        />}
        {type == "completed" && <DropdownTexts
          label={"closed on"}
          value={loanDate}
        />}
        <DropdownTexts
          label={"Loan ID"}
          value={"----"}
        />
        <DropdownTexts
          label={"AMOUNT"}
          value={"----"}
        />
        <DropdownTexts
          label={"RATE"}
          value={"----"}
        />
        <DropdownTexts
          label={"EMI"}
          value={"----"}
        />
        <DropdownTexts
          label={"Tenure"}
          value={"6 Months"}
        />
        {type == "completed" && <>
          <div className="grid grid-cols-2 gap-[4px]">
            <Button variant="quaternary" className="w-full flex justify-center text-white">
              <p className="flex gap-[8px]"><span><DownloadIcon /></span> Statement</p>
            </Button>
            <Button variant="quaternary" className="w-full flex justify-center text-white">
              <p className="flex gap-[8px]"><span><DownloadIcon /></span> NOC</p>
            </Button>
          </div>
          <div className="flex justify-center md:justify-start items-center mt-[12px] gap-[4px] text-[#424952]">
            {/* <DownloadIcon height="15" width="15" /> */}
            <ViewIcon2 />
            <p className="font-Apparat font-[500] text-[16px] leading-[12px] ">View Payment History</p>
          </div>
        </>}
        {type == "rejected" && <div className="flex flex-col gap-[7px]">
          <p className="flex gap-[7px] font-Apparat font-[500] md:font-[700] text-[12px] md:text-[16px] text-[#E53F50]  items-center" ><InfoIcon /> Reason For Rejection </p>
          <div>
            {RejectionList?.map((list, index) => <p
              className="font-Apparat font-[500] text-[12px] md:text-[16px]  leading-[24px] md:leading-[19.2px] tracking-[-2%]"
            >
              {`${index + 1}. ${list}`}
            </p>)}
          </div>
        </div>}
        {type == "rejected" && <Button title={"Apply Again"} className="flex justify-center w-full" />}
      </div>}
      {dropdownOpen && <Link class="text-primary font-Apparat font-[500] text-[10px] leading-[30px] tracking-[-2%] flex md:hidden justify-center gap-[4px] mt-[8px]">
        <ChatIcon />
        <span>Support</span>
      </Link>}
    </Card>
    <Card className="hidden md:flex flex-col justify-between gap-[9px] border-dashed border-2 min-w-[220px] h-[164px]">
      <div className="grid grid-cols-2 gap-[34px]">
        <div className="grid-span-1">
          <EMIText title="EMI" value={`All paid`} />
        </div>
        <div className="grid-span-1 text-end">
          <EMIText title="EMI Paid" value={`1/3`} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-[34px]">
        <LoanStatusText title="" statusClass={statusColor} status={value} />
      </div>
    </Card>
  </div>)
}
export default PastLoanCard;